// extracted by mini-css-extract-plugin
module.exports = {"btn":"style_btn__2kSn2","slideBanerHome":"style_slideBanerHome__320-8","bannerHome_item":"style_bannerHome_item__7rzOT","imgInside":"style_imgInside__3hks3"};